import { Backdrop, CircularProgress } from "@mui/material";

type BackdropIndicatorProps = {
  open: boolean;
};
export function BackdropIndicator({ open }: BackdropIndicatorProps) {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
